'use client';

import React from 'react';
import { MdLocalGasStation } from 'react-icons/md';

import styles from './GasTrackerPage.module.css';

const GasTrackerPage: React.FC = () => {
  return (
    <div className={ styles.container }>
      <div className={ styles.header }>
        <h1 className={ styles.title }>Gas Tracker</h1>
        <p className={ styles.subtitle }>Real-time gas prices and network congestion</p>
      </div>

      <div className={ styles.content }>
        <div className={ styles.emptyState }>
          <MdLocalGasStation size={ 64 }/>
          <h2>Gas Tracker</h2>
          <p>Monitor network gas prices</p>
        </div>
      </div>
    </div>
  );
};

export default GasTrackerPage;
